<div class="dateRangeFilterContainer">
    <span class="filterSelectorContainerChild">Filter by</span>
    <div class="filterSelectorContainerChild dateRageFilterSelectors">
        <input type="radio" id="month" name="dateRangeSelector" value="month" [(ngModel)]="selectedOption"
            (ngModelChange)="optionChanged('month', currentMonth)">
        <label class="filterSelectorChild" for="month">Month</label>
        <input type="radio" id="date" name="dateRangeSelector" value="date" [(ngModel)]="selectedOption"
            (ngModelChange)="optionChanged('date', currentDate)">
        <label class="filterSelectorChild" for="date">Date</label>
        <input type="radio" id="dateRange" name="dateRangeSelector" value="dateRange" [(ngModel)]="selectedOption"
            (ngModelChange)="optionChanged('dateRange', dateRange)">
        <label for="dateRange">Date Range</label>
    </div>
    <div class="filterSelectorContainerChild dateRangeFilterOptions">
        <input type="month" *ngIf="selectedOption === 'month'" [(ngModel)]="currentMonth" [max]="maxMonth"
            (ngModelChange)="optionChanged('month', currentMonth)">
        <input type="date" *ngIf="selectedOption === 'date'" [(ngModel)]="currentDate" [max]="maxDate"
            (ngModelChange)="optionChanged('date', currentDate)">
        <div *ngIf="selectedOption === 'dateRange'">
            <input class="filterSelectorChild" type="date" [(ngModel)]="dateRange.from"
                [max]="dateRange.to || maxDate"
                (ngModelChange)="optionChanged('dateRange', dateRange)">
            <input type="date" [(ngModel)]="dateRange.to" [min]="dateRange.from" [max]="maxDate"
                (ngModelChange)="optionChanged('dateRange', dateRange)">
        </div>
    </div>
</div>
